import WidgetCard from "@/components/cards/widget-card";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TablePagination from "@/components/table/pagination";
import { appointmentData } from "@/data/appointment-data";
import cn from "@/utils/class-names";
import { appointmentColumns } from "./columns";
import Filters from "./filters";

export type AppointmentDataType = (typeof appointmentData)[number];

export default function UpcomingAppointmentTable({
    className,
}: {
    className?: string;
}) {
    const { table, setData } = useTanStackTable<AppointmentDataType>({
        tableData: appointmentData,
        columnConfig: appointmentColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 7,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <WidgetCard
            className={cn("p-0 lg:p-0", className)}
            title="Upcoming Appointment"
            titleClassName="whitespace-nowrap"
            headerClassName="mb-4 items-start flex-col @[62rem]:flex-row @[62rem]:items-center px-5 lg:px-7 pt-5 lg:pt-7"
            actionClassName="grow @[62rem]:ps-11 ps-0 items-center w-full @[42rem]:w-full @[62rem]:w-auto"
            action={<Filters table={table} />}
        >
            <Table table={table} variant="modern" />
            <TablePagination table={table} className="p-4" />
        </WidgetCard>
    );
}
